export var constants = {
	speakers: {
		labTechDavid: {
			name: 'Lab Tech David',
			img: 'sampleimg.png'
		},
		rnMiranda: {
			name: 'RN Miranda',
			img: 'sampleimg.png'
		}
	},
	icons: {
		phone: './assets/images/general/icons/phone.png',
		feedback: './assets/images/general/icons/phone.png',
		miranda: './assets/images/general/icons/miranda.png',
		marco: './assets/images/general/icons/marco.png',
		nurseManager: './assets/images/general/icons/nurse-manager.png',
		computer: './assets/images/general/icons/computer_icon.png'
	},
	uiTags: {
		Hud: 'Hud',
		youRespond: 'you-respond'
	},
	generalAudio: {
		cellPhone: './assets/audio/general/CellPhone'
	},
	uiNames: {
		SampleScenarioUI: 'SampleScenarioUI',
		SplashScreenUI: 'SplashScreenUI',
		BeginScenarioUI: 'BeginScenarioUI',
		YouRespondUI: 'YouRespondUI',
		HeaderUI: 'HeaderUI',
		DirectionsUI: 'DirectionsUI',
		FeedbackUI: 'FeedbackUI',
		NurseStationComputerUI: 'NurseStationComputerUI',
		NurseStationComputerSingleQuestionUI: 'NurseStationComputerSingleQuestionUI',
		BadgingProgressUI: 'BadgingProgressUI',
		MedicalDispenserUI: 'MedicalDispenserUI',
		EndLevelUI: 'EndLevelUI',
		AARUI: 'AARUI',
		ResumeUI: 'ResumeUI',
		ReturnToMainMenuUI: 'ReturnToMainMenuUI',
		StaffingPlanUI: 'StaffingPlanUI',
		DelegateUI: 'DelegateUI',
		KnowledgeCheckUI: 'KnowledgeCheckUI',
		ConfirmAlertUI: 'ConfirmAlertUI'
	},
	scenarios: {
		scenario1: {
			id: 'Scenario1',
			parts: {
				level1Part1: {
					id: 'level1Part1'
				},
				level1Part2: {
					id: 'level1Part2'
				},
				level1Part3: {
					id: 'level1Part3'
				}
			}
		},
		scenario2: {
			id: 'Scenario2',
			parts: {
				level2Part1: {
					id: 'level2Part1'
				},
				level2Part2: {
					id: 'level2Part2' 
				},
				level2Part3: {
					id: 'level2Part3' 
				},
				level2Part4: {
					id: 'level2Part4' 
				},
			}
		},
		scenario3: {
			id: 'Scenario3',
			parts: {
				level3Part1: {
					id: 'level3Part1'
				},
				level3Part2: {
					id: 'level3Part2'
				},
				level3Part3: {
					id: 'level3Part3'
				},
				level3Part4: {
					id: 'level3Part4'
				},
				level3Part5: {
					id: 'level3Part5'
				},
				level3Part6: {
					id: 'level3Part6'
				}
			}
		},
		scenario4: {
			id: 'Scenario4',
			parts: {
				level4Part1: {
					id: 'level4Part1' // 13 total parts
				},
				level4Part2: {
					id: 'level4Part2' // 13 total parts
				}, 
				level4Part3: {
					id: 'level4Part3' // 13 total parts
				}, 
				level4Part4: {
					id: 'level4Part4' // 13 total parts
				}, 
				level4Part5: {
					id: 'level4Part5' // 13 total parts
				}, 
				level4Part6: {
					id: 'level4Part6' // 13 total parts
				}, 
				level4Part7: {
					id: 'level4Part7' // 13 total parts
				}, 
				level4Part8: {
					id: 'level4Part8' // 13 total parts
				}, 
				level4Part9: {
					id: 'level4Part9' // 13 total parts
				}, 
				level4Part10: {
					id: 'level4Part10' // 13 total parts
				}, 
				level4Part11: {
					id: 'level4Part11' // 13 total parts
				}, 
				level4Part12: {
					id: 'level4Part12' // 13 total parts
				}, 
				level4Part13: {
					id: 'level4Part13' // 13 total parts
				},
				level4Part14: {
					id: 'level4Part14'
				},
				level4Part15: {
					id: 'level4Part15'
				}
			}
		},
		scenario5: {
			id: 'Scenario5',
			parts: {
				level5Part1: {
					id: 'level5Part1'
				},
				level5Part2: {
					id: 'level5Part2' // 9 total parts
				}, 
				level5Part3: {
					id: 'level5Part3' // 9 total parts
				}, 
				level5Part4: {
					id: 'level5Part4' // 9 total parts
				}, 
				level5Part5: {
					id: 'level5Part5' // 9 total parts
				}, 
				level5Part6: {
					id: 'level5Part6' // 9 total parts
				}, 
				level5Part7: {
					id: 'level5Part7' // 9 total parts
				}, 
				level5Part8: {
					id: 'level5Part8' // 9 total parts
				}, 
				level5Part9: {
					id: 'level5Part9' // 9 total parts
				},	
			}
		}
	}
};